import { getCountryCode, getCountryData, getCountryDataList, getEmojiFlag } from 'countries-list'
export const ROLE_NAMES = {
  user: 'Usuario',
  professional: 'Profesional'
}
export const PRICE_TOKEN_COOKIE_NAME = 'price_token'
export const AUTH_TOKEN_COOKIE_NAME = 'jwt_session'
export const CART_ITEMS_COOKIE_NAME = 'cart_items'
export const CONSENT_COOKIE_NAME = 'cc_cookie'
export const BILLING_SESSION_NAME = 'billing_data'
export const DELIVERY_SESSION_NAME = 'delivery_data'
export const SHIPPING_SESSION_NAME = 'shipping_data'
export const USER_SESSION_NAME = 'user_data'
export const PAYMENT_METHOD_SESSION_NAME = 'payment_method'

export const EMPTY_DELIVERY_DATA = {
  type: null,
  location: null,
  company: '',
  country: 'ES',
  streetAddress: '',
  extendedAddress: '',
  locality: '',
  region: '',
  postalCode: '',
  phone: '',
  observations: '',
}

export const EMPTY_BILLING_DATA = {
  ignoreInvoice: false,
  company: '',
  vat: '',
  country: 'ES',
  streetAddress: '',
  extendedAddress: '',
  locality: '',
  region: '',
  postalCode: ''
}

export const EMPTY_SHIPPING_DATA = {
  id: null,
  title: "",
  type: "courier",
  description: "",
  tax: 1,
  price: {
    price: 0,
    original_price: 0,
    from_amount: 0,
    discount_percent: 0,
    discount_amount: 0
  }
}

export const EMPTY_REDSYS_PAYFORM = {
  url: '',
  version: '',
  merchantParameters: '',
  signature: ''
}
export const getUserInitials = (firstname, lastname) => {
  return firstname.charAt(0) + lastname.charAt(0).toUpperCase()
}

export const billingFields = ['ignoreInvoice','company', 'vat', 'streetAddress', 'extendedAddress', 'locality', 'region', 'country', 'postalCode']
export const deliveryFields = ['company', 'phone', 'streetAddress', 'extendedAddress', 'locality', 'region', 'country', 'postalCode', 'observations']

export const getUserDataFromToken = (tokenDecoded) => {
  if(!tokenDecoded) return null
  return {
    id: tokenDecoded.id,
    firstname: tokenDecoded.firstname,
    lastname: tokenDecoded.lastname,
    email: tokenDecoded.email,
    avatar: tokenDecoded.avatar,
    fullname: `${tokenDecoded.firstname} ${tokenDecoded.lastname}`,
    country: tokenDecoded.country,
    initials: getUserInitials(tokenDecoded.firstname, tokenDecoded.lastname),
    roles: tokenDecoded.roles,
    phone: tokenDecoded.phone
  }
}

export function getDeliveryDataFromAnonUser (user) {
  return {
    company: (user.firstname + ' ' + user.lastname).trim(),
    phone: user.phone,
    streetAddress: '',
    extendedAddress: '',
    locality: '',
    region: '',
    country: user.country,
    postalCode: '',
    observations: ''
  }
}

export function getBillingDataFromAnonUser (user) {
  return {
    company: (user.firstname + ' ' + user.lastname).trim(),
    vat: '',
    streetAddress: '',
    extendedAddress: '',
    locality: '',
    region: '',
    country: user.country,
    postalCode: ''
  }
}

export function getCountryNameByCode (code) {
  return getCountryData(code)?.native || code
}
